// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".waranty.waranty-quantity>input.input-text.qty.text{border:none;color:rgba(68,68,68,.7)}", ""]);
// Exports
module.exports = exports;
